import API from '@/services/api'

export default {
  /** MASTER */

  /* get all */
  getConstraints() {
    return API.get('/constraints')
  },
  /* new */
  postConstraint(obj) {
    return API.post('/constraint', {
      master_constraint_id: obj.master_constraint_id,
      constraint_type: obj.constraint_type,
      data_type: obj.data_type,
      name: obj.name,
      description: obj.description,
      default_value: obj.default_value,
      value: '',
      min_value: obj.min_value,
      max_value: obj.max_value,
      unit: obj.unit,
      modifiable: obj.modifiable
    })
  },

  /** FACILITY */

  getFacilityConstraints(facilityId) {
    return API.get('/constraints/facility/' + facilityId)
  },

  getFacilityConstraintByName(facilityId, constraintName) {
    return API.get(
      '/constraint/facility/' + facilityId + '/name/' + constraintName
    )
  },
  /* new */
  postFacilityConstraint(obj) {
    return API.post('/constraint/facility/' + obj.facility_id, {
      master_constraint_id: obj.master_constraint_id,
      facility_id: obj.facility_id,
      value: obj.value
    })
  },
  /* update */
  updateFacilityConstraint(obj) {
    return API.post('/constraint/facility/' + obj.facility_id + '/update', {
      master_constraint_id: obj.master_constraint_id,
      facility_id: obj.facility_id,
      value: obj.value
    })
  },
  /* delete */
  deleteFacilityConstraint(obj) {
    return API.post('/constraint/facility/' + obj.facility_id + '/delete', {
      master_constraint_id: obj.master_constraint_id,
      facility_id: obj.facility_id,
      value: obj.value
    })
  }
}
